import { render, staticRenderFns } from "./TripDetail.vue?vue&type=template&id=0db261f1&scoped=true&"
import script from "./TripDetail.vue?vue&type=script&lang=ts&"
export * from "./TripDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TripDetail.vue?vue&type=style&index=0&id=0db261f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db261f1",
  null
  
)

export default component.exports